import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import * as UserDataConfig from '../../config/user-data.config';

@Component({
  selector: 'app-dependant-medical-conditions',
  templateUrl: './dependant-medical-conditions.component.html',
  styleUrls: ['./dependant-medical-conditions.component.scss']
})
export class DependantMedicalConditionsComponent implements OnInit {

  public contentData: object;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public userForm: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.dependantMedicalConditions;
   }

  ngOnInit() {
    this.userFormData();
  }

  userFormData = () => {
    this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  gotoNextPage = () => {
    this.router.navigate(['/quote/your-product-options']);
  }
}
